export const getCurrentUser = () => {
	return {
		type: "CURRENT_USER",
	};
};

export const setModule = (data) => {
	return {
		type: "CURRENT_MODULE",
		payload: data,
	};
};

export const setCurrentPageSize = (data) => {
	return {
		type: "CURRENT_PAGE_SIZE",
		payload: data,
	};
};

export const setLoading = (data) => {
	return {
		type: "SET_LOADING",
		payload: data,
	};
};

export const logOut = () => {
	localStorage.removeItem("webuser");
	window.location.reload();
	return {
		type: "LOGOUT",
	};
};
